import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'lib-overflow-menu-button',
  standalone: true,
  template: `
    <button
      type="button"
      class="overflow-menu-button"
      [class.overflow-menu-button--open]="isOpen"
      [disabled]="disabled"
      [attr.aria-label]="ariaLabel"
      [attr.aria-haspopup]="'menu'"
      [attr.aria-expanded]="isOpen"
      (click)="buttonClicked.emit()"
    >
      <span></span>
      <span></span>
      <span></span>
    </button>
  `,
  styles: [`
    .overflow-menu-button {
      width: 34px;
      height: 34px;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      gap: 3px;
      border: 1px solid #dbe2ea;
      border-radius: 999px;
      background:
        linear-gradient(180deg, rgba(255, 255, 255, 0.98), rgba(248, 250, 252, 0.96));
      color: #334155;
      cursor: pointer;
      box-shadow: 0 1px 2px rgba(15, 23, 42, 0.05);
      transition:
        background-color 0.16s ease,
        border-color 0.16s ease,
        box-shadow 0.16s ease,
        transform 0.16s ease;
      padding: 0;
    }

    .overflow-menu-button:hover:not(:disabled),
    .overflow-menu-button--open {
      background:
        linear-gradient(180deg, rgba(255, 255, 255, 1), rgba(241, 245, 249, 1));
      border-color: #cbd5e1;
      color: #0f172a;
      box-shadow: 0 8px 18px rgba(15, 23, 42, 0.08);
      transform: translateY(-1px);
    }

    .overflow-menu-button:focus-visible {
      outline: 2px solid #2563eb;
      outline-offset: 2px;
    }

    .overflow-menu-button:disabled {
      opacity: 0.5;
      cursor: default;
    }

    .overflow-menu-button span {
      width: 4px;
      height: 4px;
      border-radius: 999px;
      background: currentColor;
      display: block;
      opacity: 0.92;
    }
  `],
})
export class OverflowMenuButtonComponent {
  @Input() public ariaLabel = 'Open actions menu';
  @Input() public disabled = false;
  @Input() public isOpen = false;

  @Output() public readonly buttonClicked = new EventEmitter<void>();
}
